import {handleRepositoryDataError} from '@github-ui/data-router-error-helpers'
import {useRouteParams} from '@github-ui/react-core/future/use-route-params'
import {useRouteQuery} from '@github-ui/react-core/future/use-route-query'
import {AnalyticsWrapper as BaseAnalyticsWrapper} from '@github-ui/repo-issues-page-layout/AnalyticsWrapper'
import {RepoIssuesPageLayout} from '@github-ui/repo-issues-page-layout/RepoIssuesPageLayout'
import {useRepoIssuesSidebarLayoutEnabled} from '@github-ui/repo-issues-page-layout/useSidebarLayoutEnabled'
// eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-imports -- MilestoneCreate is Relay-free, but the repository-milestone package still bundles Relay components (edit/toggle/delete).
import {MilestoneCreate} from '@github-ui/repository-milestone/MilestoneCreate'

import {issuesLayoutRoute} from './issues-layout-route'
import {milestoneNewRoute} from './milestone-new-route'
import {useRenderSidebar} from './render-issues-sidebar'

export function MilestoneNew() {
  const {owner, repo} = useRouteParams(milestoneNewRoute)
  const {data: layoutPayload} = useRouteQuery(issuesLayoutRoute, 'mainQuery')
  const payload = useRouteQuery(milestoneNewRoute, 'mainQuery')

  const renderSidebarFn = useRenderSidebar(owner, repo, layoutPayload)
  const sidebarLayoutEnabled = useRepoIssuesSidebarLayoutEnabled()

  // FORBIDDEN/SAML reloads the page; other errors throw to the boundary.
  const data = handleRepositoryDataError(payload.data)
  if (!data?.repository) {
    return null
  }

  // Each issues leaf owns its RepoIssuesPageLayout (the parent is a passthrough).
  return (
    <BaseAnalyticsWrapper category="Repository Milestone New" appName="issues">
      <RepoIssuesPageLayout
        dialogTitle="Milestones"
        title={sidebarLayoutEnabled ? 'Create milestone' : undefined}
        renderSidebar={renderSidebarFn}
        initialExpanded={layoutPayload?.sidebar_expanded ?? undefined}
      >
        <MilestoneCreate repository={data.repository} />
      </RepoIssuesPageLayout>
    </BaseAnalyticsWrapper>
  )
}
